import { FacilityGroupSortOption } from '@rematter/frontend-lib-api-client';

import { ObjectRefRecord } from '~/shared/components/custom-attributes/types';
import { createQueryHook } from '~/shared/providers/api';

export const useFacilityGroupsQuery = createQueryHook(
  'facilities.facilityGroups',
  (params: {
    searchTerm?: string;
    sorting?: FacilityGroupSortOption[];
    limit?: number;
    offset?: number;
  }) => ({
    facilityGroups: {
      __args: {
        filter: params.searchTerm
          ? {
              searchTerm: params.searchTerm,
            }
          : undefined,
        sorting: params.sorting,
        pagination: {
          limit: params.limit ?? 10,
          offset: params.offset ?? 0,
        },
      },
      entries: {
        id: true,
        name: true,
      },
      page: {
        total: true,
      },
    },
  }),
  {
    select: (data): ObjectRefRecord[] =>
      data?.facilityGroups.entries.map((group) => ({
        id: group.id,
        name: group.name,
      })) ?? [],
  },
);
